import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function TickerBar() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(false), 12000);
    return () => window.clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const headlines = topics.slice(0, 6);

  return (
    <div className="relative w-full bg-primary-600 text-background-50">
      <div className="mx-auto flex h-9 max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 text-xs font-medium tracking-wide">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-flashlight-fill text-secondary-300" />
          </span>
          瓜田快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max items-center gap-10 whitespace-nowrap hg-marquee">
            {headlines.concat(headlines).map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/topic/${item.id}`}
                className="text-xs text-background-50/90 transition-colors hover:text-secondary-200"
              >
                {item.title}
              </Link>
            ))}
          </div>
        </div>
        <button
          type="button"
          onClick={() => setVisible(false)}
          aria-label="关闭快讯条"
          className="flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center text-background-50/70 transition-colors hover:text-background-50"
        >
          <i className="ri-close-line text-sm" />
        </button>
      </div>
    </div>
  );
}